import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=581bb9b2&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=581bb9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581bb9b2",
  null
  
)

export default component.exports